<template>
  <div class="quick-search" v-if="$can('viewVehicle') || $can('listJobs')">
    <v-col :cols="displayDatePicker? 3: 4">
      <v-text-field 
        v-model="quickSearchTerm"
        class="text-white"
        label="Enter search term"
      />
    </v-col>
    <v-col :cols="displayDatePicker? 3: 4">
      <v-select 
        v-model="selectedSearchType" 
        class="text-white"
        :items="FilteredSearchType" 
        item-text="label"
        item-value="value"
      />
    </v-col>
    <v-col v-if="displayDatePicker" cols="6">
      <material-date-time-range 
        :start-value="startValue" 
        :local-time="true"
        :white-theme="true"
        @change="range => selectDateRange = range">
      </material-date-time-range>
    </v-col>
    <v-col cols="1" class="display-flex">
      <v-icon 
        v-if="!searching" 
        color="white" 
        class="hover-state"
        @click="submit"
      >
        mdi-magnify
      </v-icon>
      <v-progress-circular
        v-else
        class="search-loading"
        indeterminate
        size="30"
        color="white"
      ></v-progress-circular>
    </v-col>
    <v-col cols="1" class="display-flex">
      <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          color="white" 
          class="hover-state advanced-search-btn"
          v-bind="attrs"
          v-on="on"
          @click="toggleAdvancedSearch"
        >
        mdi-dots-horizontal
      </v-icon>
      </template>
      <span>Advanced Search</span>
    </v-tooltip>
      
    </v-col>

    <AdvancedSearch
      :display="showAdvancedSearch"
      @close="closeAdvancedSearch"
    />
  </div>
</template>

<script>

import { search } from '@/mixins/quickSearch.js'

import moment from "moment";

import AdvancedSearch from './components/AdvancedSearch.vue';

import { AmplifyEventBus } from "aws-amplify-vue"

// import { Logger } from "aws-amplify"
// const logger = new Logger("Global Search / Search")

export default {
  name: 'Search',
  components: {
    AdvancedSearch
  },
  mixins: [ search ],
  data() {
    return {
      startValue: [
        moment()
          .subtract(7, "days")
          .startOf("day")
          .utc()
          .format()
          .split("Z")
          .join(""),
        moment()
          .endOf("day")
          .utc()
          .format()
          .split("Z")
          .join("")
      ],
      selectDateRange: [
        moment()
          .subtract(7, "days")
          .startOf("day")
          .utc()
          .format()
          .split("Z")
          .join(""),
        moment()
          .endOf("day")
          .utc()
          .format()
          .split("Z")
          .join("")
      ],
      searching: false,
      searchType: [
        {
          label: 'Jobs',
          value: 'jobs'
        },
        {
          label: 'Vehicles',
          value: 'vehicles'
        },
        {
          label: 'Devices',
          value: 'devices'
        }
      ],
      selectedSearchType: '',
      quickSearchTerm: '',
      showAdvancedSearch: false,
      searchPayload: {
        jobs: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [
            {
              attribute: 'start_timestamp',
              value: '',
              type: 'filter'
            },
            {
              attribute: 'end_timestamp',
              value: '',
              type: 'filter'
            },
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        },
        vehicles: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [ 
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        },
        devices: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [ 
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        }
      },
    }
  },
  computed: {
    displayDatePicker() {
      return this.selectedSearchType == 'jobs' ? true : false;
    },
    searchTooltip() {
      return this.searching ? 'Searching...' : 'Submit search'
    },
    currentRoute() {
      return this.$route.path;
    },
    FilteredSearchType () {
      const hidden = {
        'jobs': !this.$can('listJobs'),
        'vehicles': !this.$can('viewVehicle'),
      }
      return this.searchType.filter(i => !hidden[i.value])
    }
  },
  watch: {
    selectDateRange: {
      handler(dates) {
        let start = this.searchPayload[this.selectedSearchType].criteria.find(item => item.attribute == 'start_timestamp');
        let end = this.searchPayload[this.selectedSearchType].criteria.find(item => item.attribute == 'end_timestamp');
        
        if(start && end) {
          start.value = dates[0];
          end.value = dates[1];
        }
      }
    },
    quickSearchTerm: {
      handler(search) {
        let term = this.searchPayload[this.selectedSearchType].criteria.find(item => item.attribute == '*');

        term.value = search;
      }
    },
    selectedSearchType: {
      handler(value) {
        let term = this.searchPayload[this.selectedSearchType].criteria.find(item => item.attribute == '*');

        // reset search terms on change of search type
        term.value = '';
        this.quickSearchTerm = ''
        this.searchPayload[this.selectedSearchType].category = value;
      }
    }
  },
  mounted() {
    window.EventBus.$on('closeAdvancedSearch', this.closeAdvancedSearch)
    // Pre-pop search type dropdown
    this.selectedSearchType = this.searchType[0].value;
    this.selectDateRange = this.startValue;
  },
  methods: {
    closeAdvancedSearch() {
      this.showAdvancedSearch = false;
    },
    toggleAdvancedSearch() {
      this.showAdvancedSearch = !this.showAdvancedSearch;
    },
    async submit() {
      this.searching = true;

      try {
      window.EventBus.$emit('initSearchPage')
      this.searchPayload[this.selectedSearchType].pageNum = 1
      const search = await this.quickSearch(this.searchPayload[this.selectedSearchType], this.currentRoute);

        if (search.Result) {
          // Resets selected page on search results page pagination to 1
          this.searching = false;
        }
        else {
          this.searching = false;
          AmplifyEventBus.$emit("snackEvent", {
            color: "error",
            text: 'An error occurred - please try again later'
          });
        }
      }
      catch {
        this.searching = false;
        AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: 'An error occurred - please try again later'
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .quick-search {
    display: flex;

    .text-white input, label {
      color: white !important;
    }

    .display-flex {
      display: flex;
    }

    .hover-state {
      input { 
        cursor: pointer;
      }
    }

    .search-loading {
      padding-top: 3em;
    }

    /*
    These are the selectors controlling the selected item
    in v-autocomplete and v-select
    */
    .v-select__selection,
    .v-select__selection--comma,
    .v-select.v-text-field input {
      color: white !important;
    }

    .advanced-search-btn {
      &:focus {
          outline: none;
      }
    }
    .mdi-menu-down::before {
      color: white;
    }
  }
</style>